import { useQuery } from '@tanstack/react-query';
import jsCookie from 'js-cookie';

import { AssetItemProps } from '@/shared/components/molecules/ChooseAsset/ChooseAsset';
import axiosClient from '@/shared/lib/axios';
import { IGeneral } from '@/shared/types';

export const getAssetsList = async (): Promise<{
  entities: AssetItemProps[];
  companyTypeId: number;
  isCompanyInventoryActive: 1 | 0;
  isCompanyFacialRecognitionActive: 1 | 0;
}> => {
  const { data } = await axiosClient.get('/company/entity');
  return data;
};
export const useGetAssetsList = (isCompanyUser?: boolean) => {
  //  staleTime: Infinity call this api only once
  // and we will remove cach when logout to get update data when back and login
  return useQuery(['getEntities'], () => getAssetsList(), {
    staleTime: Infinity,
    enabled: !!isCompanyUser,
  });
};
export const useGetCountries = () => {
  return useQuery(
    ['countries'],
    (): Promise<IGeneral.GetCountriesItemSchema[]> =>
      axiosClient.get(`/countries`).then((res) => res.data)
  );
};
export const useGetCurrencies = () => {
  return useQuery(
    ['currencies'],
    (): Promise<string[]> =>
      axiosClient.get(`/currencies`).then((res) => res.data)
  );
};
export const useGetStatesByCountry = ({
  countryCode,
}: {
  countryCode: string | undefined;
}) => {
  return useQuery(
    ['states-by-country', countryCode],
    (): Promise<IGeneral.GetStatesByCountryItemSchema[]> =>
      axiosClient
        .get(`/states-by-country`, {
          params: {
            countryCode,
          },
        })
        .then((res) => res.data),
    {
      enabled: Boolean(countryCode),
    }
  );
};
export const useGetCitiesByStates = ({
  countryCode,
  stateCode,
}: {
  stateCode: string | undefined;
  countryCode: string | undefined;
}) => {
  return useQuery(
    ['cities-by-state', countryCode, stateCode],
    (): Promise<IGeneral.GetCitiesByStateItemSchema[]> =>
      axiosClient
        .get(`/cities-by-state`, {
          params: {
            countryCode,
            stateCode,
          },
        })
        .then((res) => res.data),
    {
      enabled: Boolean(countryCode && stateCode),
    }
  );
};

//**************  TIMEZONES ****************/
const getTimezones = async (): Promise<string[]> => {
  const { data } = await axiosClient.get('/time-zones');
  return data;
};

export const useGetTimezones = () => {
  return useQuery({
    queryKey: ['getTimezones'],
    queryFn: getTimezones,
  });
};

const getOnboardingStatus =
  async (): Promise<IGeneral.IGetOnboardingStatusResponse> => {
    const { data } = await axiosClient.get(
      '/company/portalInsights/home-page/sidebar-checks'
    );
    return data;
  };

export const useGetOnboardingStatus = (isCompanyUser?: boolean) => {
  const token = jsCookie.get('token');
  return useQuery({
    queryKey: ['getOnboardingStatus'],
    queryFn: getOnboardingStatus,
    staleTime: Infinity,
    enabled: Boolean(token) && isCompanyUser,
  });
};
